import { useQuery } from "react-query"
import { queryKeys } from "../../client"
import api from "../../api"
import query from "../../function/query"

const getData = async (machineId) => {
  const qs = query.toString({
    machine: machineId,
    limit: 0,
    offset: 0,
    type: "PREVENTION",
    active: 1,
  })

  const { data } = await api.get(`/tasks/unique${qs}`)

  return data.data
}

export const usePreventionsUnique = (machineId) => {
  const { data, ...props } = useQuery(
    queryKeys.TASK_PREVENTION_UNIQUE(machineId),
    () => getData(machineId),
    { enabled: !!machineId }
  )
  return { data, ...props }
}
